import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";

// project-imports
import {
  GoogleAnalyticsEnum,
  triggerFunction,
} from "../../utils/google-analytics";
import { useUserContext } from "../../context/user_context";
import { _setBgColor } from "../../utils";
import menuList from "../../data/menu/menuList.json";

// third-party
import Avatar from "react-avatar";
import CalendlyPopupButton from "../../components/calendly/CalendlyPopupButton";

// Reading ENV variables
const BOOK_CONSULTATION_LINK = process.env.REACT_APP_BOOK_FREE_SESSION_LINK;
const BOOK_CONSULATION_LINK_TEXT =
  process.env.REACT_APP_BOOK_FREE_SESSION_LINK_TEXT;

const NavLandingDemo = ({
  isHomePage,
  onClose,
  isResponsive,
  isDrawerOpen,
  isUserLogged,
}) => {
  // reading context method
  const { handleSignOut } = useUserContext();
  const { pathname } = useLocation();

  // local stat initialization
  const [activeTab, setActiveTab] = useState(
    window.location.hash || window.location.pathname,
  );
  const [userDrawer, setUserDrawer] = useState(false);
  const [menuItem, setMenuItem] = useState("");

  // Constant Function
  const handleClick = (analyticsEnum) => {
    try {
      if (isResponsive) {
        onClose();
        triggerFunction(GoogleAnalyticsEnum.LINK, analyticsEnum);
      } else {
        triggerFunction(GoogleAnalyticsEnum.LINK, analyticsEnum);
      }
    } catch (error) {
      console.log(
        "40 : NavLandingDemo : Error in handleClick :: ",
        error && JSON.stringify(error),
      );
    }
  };

  useEffect(() => {
    menuList.forEach((elm) => {
      elm?.subMenu?.forEach((elm2) => {
        if (elm2.href?.split("/")[1] === pathname.split("/")[1]) {
          setMenuItem(elm.title);
        } else {
          elm2?.subMenu?.map((elm3) => {
            if (elm3.href?.split("/")[1] === pathname.split("/")[1]) {
              setMenuItem(elm.title);
            }
          });
        }
      });
    });
  }, []);
  return (
    <ul className="mainmenu">
      {!isResponsive && isDrawerOpen && (
        <>
          {!isUserLogged ? (
            <>
              {/* <li>
                <RouterLink
                  className={`landing-demo-nav-btn ${activeTab === "/login" && window.location.hash === "" ? "active" : ""}`}
                  to="/login"
                  // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
                  onClick={() => {
                    handleClick(GoogleAnalyticsEnum.HEADER_HOME);
                    setActiveTab("/login");
                  }}
                >
                  Login <i className="ri-arrow-right-long-line"></i>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  className={`landing-demo-nav-btn ${activeTab === "/register" && window.location.hash === "" ? "active" : ""}`}
                  to="/register"
                  // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
                  onClick={() => {
                    handleClick(GoogleAnalyticsEnum.HEADER_HOME);
                    setActiveTab("/register");
                  }}
                >
                  Register <i className="ri-arrow-right-long-line"></i>
                </RouterLink>
              </li> */}

              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                <RouterLink
                  className={`edu-btn btn-dark btn-small ${activeTab === "/login" && window.location.hash === "" ? "active" : ""}`}
                  to="/login"
                  // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
                  onClick={() => {
                    handleClick(GoogleAnalyticsEnum.HEADER_HOME);
                    setActiveTab("/login");
                  }}
                >
                  Login
                </RouterLink>
                <RouterLink
                  // className={`color-primary text-decoration-underline ${activeTab === "/register" && window.location.hash === "" ? "active" : ""}`}
                  className={`edu-btn btn-border-primary btn-small ${activeTab === "/register" && window.location.hash === "" ? "active" : ""}`}
                  to="/register"
                  // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
                  onClick={() => {
                    handleClick(GoogleAnalyticsEnum.HEADER_HOME);
                    setActiveTab("/register");
                  }}
                >
                  Create An Account
                </RouterLink>
              </div>
              <div className="border-top-1 mt--10" />


            </>
          ) : (
            <>
              <li>
                <RouterLink
                  className={`landing-demo-nav-btn`}
                  // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
                  onClick={() => {
                    handleClick(GoogleAnalyticsEnum.HEADER_HOME);
                  }}
                >
                  <div className="container">
                    <div className="row text-center overflow-hidden">
                      <div className="col-12 p-0 d-flex justify-content-center my-auto">
                        {(isUserLogged && isUserLogged?.profileImg?.publicUrl) ? (
                          <div className="avatar-dropdown-icon">
                            <img
                              src={(isUserLogged && isUserLogged?.profileImg?.publicUrl) || ""}
                              alt={isUserLogged?.userFullName}
                              className="w-100 h-100 object-fit-cover rounded-circle"
                            />
                          </div>
                        ) : (
                          <Avatar size={'30'} maxInitials={1} color={"#525FE1"} name={(isUserLogged && isUserLogged?.userFullName) || "Guest User"} textSizeRatio={2.50} round />
                        )}
                      </div>
                      <div className="col-12 align-items-center p-0">
                        <div className="fs-3 fw-bold text-dark text-truncate ... w-full">
                          {(isUserLogged && isUserLogged?.userFullName) ||
                            "Guest User"}
                        </div>
                        <div className="fs-4 fw-bold text-secondary mt-0.5 text-truncate ... w-full">
                          {(isUserLogged && isUserLogged?.userId) ||
                            "Longswitch Academy"}
                        </div>
                        <div className="d-flex align-items-baseline justify-content-center">
                          <RouterLink
                            className={`btn-transparent color-primary  ${activeTab === `/user-details/${isUserLogged && isUserLogged?.userRecordId}` ? "active" : ""}`}
                            to={
                              process.env.PUBLIC_URL +
                              `/user-details/${isUserLogged && isUserLogged?.userRecordId}`
                            }
                          >
                            <i class="ri-user-line pr--5"></i>
                            <span> View Profile </span>
                            <i class="icon-arrow-right-line-right pl--5"></i>
                          </RouterLink>
                        </div>
                      </div>
                      {/* <div
                      className="col-1 align-items-end p-0"
                      onClick={() => setUserDrawer(true)}
                    >
                      <i className="ri-arrow-right-s-line"></i>
                    </div> */}
                    </div>
                  </div>
                  {/* <div
                  className={`popup-mobile-menu ${userDrawer ? "active" : ""}`}
                >
                  <div className="inner">
                    <div className="header-top p-2">
                      <i
                        className="ri-arrow-left-s-line"
                        onClick={() => setUserDrawer(false)}
                      ></i>
                    </div>
                    
                    <div>
                      <RouterLink
                        className="fs-3 text-secondary p-2 d-flex align-items-center"
                        to={
                          process.env.PUBLIC_URL +
                          `/user-details/${isUserLogged && isUserLogged?.userRecordId}`
                        }
                      >
                        <i class="ri-user-line pr--5"></i>
                        <span> My Profile </span>
                      </RouterLink>
                    
                      <RouterLink
                        className="fs-3 text-secondary p-2 d-flex align-items-center"
                        onClick={() => handleSignOut()}
                      >
                        <i class="ri-logout-box-r-line pr--5"></i>
                        <span> Sign Out </span>
                      </RouterLink>
                    </div>
                  </div>
                </div> */}
                </RouterLink>
              </li>

              {/* <li className={!isResponsive && isDrawerOpen ? `d-block` : "d-none"}>
                <RouterLink
                  className={`text-secondary d-flex align-items-center justify-content-center`}
                  to={
                    process.env.PUBLIC_URL +
                    `/user-details/${isUserLogged && isUserLogged?.userRecordId}`
                  }
                >
                  <i class="ri-user-line color-primary pr--5"></i>
                  <span> My Profile </span>
                </RouterLink>
              </li> */}
            </>
          )}
        </>
      )}

      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === "/" && window.location.hash === "" ? "active" : ""}`}
          to="/"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_HOME);
            setActiveTab("/");
          }}
        >
          Home
        </RouterLink>
      </li>
      {/* <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ''}>
        {!isHomePage && (
          <RouterLink
            className={`landing-demo-nav-btn ${activeTab === '/salesforce-courses' ? 'active' : ''}`}
            to="/salesforce-courses"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_COURSES);
              setActiveTab('/salesforce-courses');
            }}
          >
            Courses
          </RouterLink>
        )}
        {isHomePage && (
          <Link
            className={`landing-demo-nav-btn ${activeTab === '/salesforce-courses' ? 'active' : ''}`}
            to="/salesforce-courses"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_HOME_COURSES);
              setActiveTab('/salesforce-courses');
            }}
          >
            Courses
          </Link>
        )}
      </li> */}
      <li className={`has-droupdown ${!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}`}>
        <RouterLink
          data-barba
          to="#"
          className={menuItem === "Interview Q&A" ? "active" : ""}
        >
          Interview Q&A
        </RouterLink>
        <ul className="submenu">
          {(menuList || [])?.map((elm, i) => (
            elm?.subMenu?.map((list, i) => (
              <li
                key={i}

              >
                <RouterLink key={i} data-barba to={list?.href} className={
                  pathname.split("interview-questions/")[1] === list.href.split("interview-questions/")[1]
                    ? "active"
                    : ""
                }
                >
                  {list?.label || ""}
                </RouterLink>
              </li>
            ))
          ))}
        </ul>
      </li>
      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === "/salesforce-quick-insights/all" ? "active" : ""}`}
          to="/salesforce-quick-insights/all"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_SALESFORCE_QUICK_INSIGHTS);
            setActiveTab("/salesforce-quick-insights/all");
          }}
        >
          Quick Insights
        </RouterLink>
      </li>
      {/* <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        {!isHomePage && (
          <RouterLink
            className={`landing-demo-nav-btn ${activeTab === "/blogs" ? "active" : ""}`}
            to="/blogs"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_FEATURES);
              setActiveTab("/blogs");
            }}
          >
            Blogs
          </RouterLink>
        )}
        {isHomePage && (
          <Link
            className={`landing-demo-nav-btn ${activeTab === "/blogs" ? "active" : ""}`}
            to="blogs"
            // calling onCanvasHandler method which is coming from NavLandingResponsiveMenu
            // and NavLandingResponsiveMenu getting this method from HeaderLandingPage 16/02/2024
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_HOME_FEATURES);
              setActiveTab("/blogs");
            }}
          >
            Features
          </Link>
        )}
      </li> */}
      {/* <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ''}>
        {!isHomePage && (
          <RouterLink
            className={`landing-demo-nav-btn ${activeTab === '/faqs' ? 'active' : ''}`}
            to="/faqs"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_ALL_FAQS);
              setActiveTab('/faqs');
            }}
            duration={200}
          >
            FAQ
          </RouterLink>
        )}
        {isHomePage && (
          <Link
            className={`landing-demo-nav-btn ${activeTab === '/faqs' ? 'active' : ''}`}
            to="faqs"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.HEADER_HOME_FAQS);
              setActiveTab('/faqs');
            }}
          >
            FAQ
          </Link>
        )}
      </li> */}
      {/* <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ''}>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === '/about-us' ? 'active' : ''}`}
          to="/about-us"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_ABOUT_US);
            setActiveTab('/about-us');
          }}
        >
          About
        </RouterLink>
      </li> */}
      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === "/salesforce-tutorials" ? "active" : ""}`}
          to="/salesforce-tutorials"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_TUTORIALS);
            setActiveTab("/salesforce-tutorials");
          }}
        >
          Tutorials
        </RouterLink>
      </li>
      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        {!isHomePage && (
          <RouterLink
            className={`landing-demo-nav-btn ${activeTab === `/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}` ? "active" : ""}`}
            to={`/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`}
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.SF_ALL_PRICING);
              setActiveTab(
                `/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`,
              );
            }}
            duration={200}
          >
            Pricing
          </RouterLink>
        )}
        {isHomePage && (
          <Link
            className={`landing-demo-nav-btn ${activeTab === `/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}` ? "active" : ""}`}
            to={`our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`}
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.SF_ALL_PRICING);
              setActiveTab(
                `/our-offerings/${process.env.REACT_APP_OFFERING_TYPE_ADMIN}`,
              );
            }}
          >
            Training
          </Link>
        )}
      </li>
      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        {!isHomePage && (
          <RouterLink
            className={`landing-demo-nav-btn ${activeTab === "/our-resources/paid" ? "active" : ""}`}
            to="/our-resources/paid"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.SF_ALL_RESOURCES);
              setActiveTab("/our-resources/paid");
            }}
            duration={200}
          >
            E-Books
          </RouterLink>
        )}
        {isHomePage && (
          <Link
            className={`landing-demo-nav-btn ${activeTab === "/our-resources/paid" ? "active" : ""}`}
            to="our-resources/paid"
            // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
            onClick={() => {
              handleClick(GoogleAnalyticsEnum.SF_ALL_RESOURCES);
              setActiveTab("/our-resources/paid");
            }}
          >
            E-Books
          </Link>
        )}
      </li>
      <li className={!isResponsive && isDrawerOpen ? `d-block d-xxl-none` : ""}>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === "/contact-us" ? "active" : ""}`}
          to="/contact-us"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_CONTACT_US);
            setActiveTab("/contact-us");
          }}
        >
          Contact
        </RouterLink>
      </li>

      {isUserLogged ?
        <li className={!isResponsive && isDrawerOpen ? `d-block` : "d-none"}>
          <RouterLink
            className=" text-danger d-flex align-items-center justify-content-center"
            onClick={() => handleSignOut()}
          >
            <i class="ri-logout-box-r-line pr--5"></i>
            <span> Sign Out </span>
          </RouterLink>
        </li>
        :
        <></>
      }

      {/* <li>
        <RouterLink
          className={`landing-demo-nav-btn ${activeTab === '/testimonial' ? 'active' : ''}`}
          to="/testimonial"
          // changes for google analytics Adding functionality to work for when onClose() has to call 17/04/2024
          onClick={() => {
            handleClick(GoogleAnalyticsEnum.HEADER_CONTACT_US);
            setActiveTab('/testimonial');
          }}
        >
          Testimonial
        </RouterLink>
      </li> */}
      {isDrawerOpen && (
        <li className="pt-3">
          {/* TODO: 13012026 - Added the new route of Book Consultation instead of the Calendly Btn | Longswitch Front-End Team */}
          {/* TODO: 02022026 - Commented the newly Added route of Book Consultation | Longswitch Front-End Team */}
          <CalendlyPopupButton
            btnText="Book 1:1 Consultation"
            color="#F86F03"
            className="edu-btn subscribe btn-small m-0"
          />
          {/* <a href={process.env.PUBLIC_URL + "/get-free-consultation"}
            target="_self"
            onClick={() =>
              triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES)}
            className="edu-btn btn-consultation subscribe btn-small m-0 fs-4" rel="noreferrer">
            Get Free Consultation <i className="icon-arrow-right-line-right"></i>
          </a> */}
        </li>
      )}
    </ul>
  );
};

export default NavLandingDemo;
